import { Button, Drawer, Flex, message } from "antd"
import { useContext } from "react"
import { CatalogBrowserContextWrapper } from "../../../ItemCatalog/CatalogBrowserContext"
import JobPlanContext from "../JobPlanContext"
import GroupEditor from "./GroupEditor/GroupEditor"
import Sidebar from "./Sidebar"
import WorkareaEditor from "./WorkareaEditor"

const EditorDrawer = () => {
  const { currentSelection, clearSelection, isTotalsCalculating, setPendingAction } = useContext(JobPlanContext)

  const handleClose = () => {
    if (isTotalsCalculating) {
      message.loading('Waiting for totals calculations to complete...', 0)
      setPendingAction(() => () => {
        message.destroy()
        clearSelection()
      })
      return
    }
    clearSelection()
  }

  return <Drawer
    width={'100vw'}
    open={currentSelection !== undefined}
    maskClosable={false}
    styles={{
      header: { display: 'none' },
      body: { padding: 0 }
    }}
    footer={<Flex justify='end'>
      <Button type='primary' onClick={handleClose}>Close</Button>
      <div style={{ width: '75px' }}></div>
    </Flex>}
  >
    <CatalogBrowserContextWrapper allowDragging showTemplates>
      <Flex>
        <Sidebar />
        <div style={{ backgroundColor: '#fafafa', width: 'calc(100vw - 380px)', zIndex: 0 }}>
          {currentSelection?.type === 'workarea' && <WorkareaEditor />}
          {currentSelection?.type === 'group' && <GroupEditor />}
        </div>
      </Flex>
    </CatalogBrowserContextWrapper>
  </Drawer>
}

export default EditorDrawer